import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["areEventsDraggable", "areEventsResizable", "canDragEventsFromTheOutside", "canDropEventsToTheOutside", "dateLocale", "defaultPreferences", "defaultView", "defaultVisibleDate", "defaultVisibleResources", "displayTimezone", "eventColor", "eventCreation", "eventModelStructure", "events", "onEventsChange", "onViewChange", "onVisibleDateChange", "onVisibleResourcesChange", "preferences", "preferencesMenuConfig", "readOnly", "dataSource", "resourceModelStructure", "resources", "showCurrentTimeIndicator", "view", "views", "visibleDate", "visibleResources"];
import * as React from 'react';
export function useExtractEventCalendarParameters(props) {
  const {
      areEventsDraggable,
      areEventsResizable,
      canDragEventsFromTheOutside,
      canDropEventsToTheOutside,
      dateLocale,
      defaultPreferences,
      defaultView,
      defaultVisibleDate,
      defaultVisibleResources,
      displayTimezone,
      eventColor,
      eventCreation,
      eventModelStructure,
      events,
      onEventsChange,
      onViewChange,
      onVisibleDateChange,
      onVisibleResourcesChange,
      preferences,
      preferencesMenuConfig,
      readOnly,
      dataSource,
      resourceModelStructure,
      resources,
      showCurrentTimeIndicator,
      view,
      views,
      visibleDate,
      visibleResources
    } = props,
    forwardedProps = _objectWithoutPropertiesLoose(props, _excluded);
  const parameters = React.useMemo(() => ({
    areEventsDraggable,
    areEventsResizable,
    canDragEventsFromTheOutside,
    canDropEventsToTheOutside,
    dateLocale,
    defaultPreferences,
    defaultView,
    defaultVisibleDate,
    defaultVisibleResources,
    displayTimezone,
    eventColor,
    eventCreation,
    eventModelStructure,
    events,
    onEventsChange,
    onViewChange,
    onVisibleDateChange,
    onVisibleResourcesChange,
    preferences,
    preferencesMenuConfig,
    readOnly,
    dataSource,
    resourceModelStructure,
    resources,
    showCurrentTimeIndicator,
    view,
    views,
    visibleDate,
    visibleResources
  }), [areEventsDraggable, areEventsResizable, canDragEventsFromTheOutside, canDropEventsToTheOutside, dateLocale, defaultPreferences, defaultView, defaultVisibleDate, defaultVisibleResources, displayTimezone, eventColor, eventCreation, eventModelStructure, events, onEventsChange, onViewChange, onVisibleDateChange, onVisibleResourcesChange, preferences, preferencesMenuConfig, readOnly, dataSource, resourceModelStructure, resources, showCurrentTimeIndicator, view, views, visibleDate, visibleResources]);
  return {
    parameters,
    forwardedProps: forwardedProps
  };
}